import React from 'react'

export const AuthLayout = ({
    heading,
    title,
    children,
    footer,
}) => {
    return (
        <section className="auth_section gv_auth">
            <div className="gv_auth__banner">
                <img
                    className="gv_auth__banner-animated"
                    src="/images/gv-logo.gif"
                    alt="Global Village – Language & Cultural Solutions"
                />
                <img
                    className="gv_auth__banner-static"
                    src="/images/gv-login-banner.jpg"
                    alt=""
                    aria-hidden="true"
                />
            </div>
            <div className="gv_auth__panel">
                <div className='card_form_wrapper'>
                    <div className='auth_heading'>
                        <h1>{heading}</h1>
                        {title ? <p>{title}</p> : null}
                    </div>
                    {children}

                    <p className="gv_auth__powered">
                        <span>Powered by</span>
                        <a
                            href="https://algovisolutions.com/"
                            target="_blank"
                            rel="nofollow noopener noreferrer"
                            aria-label="Algovi (opens in a new tab)"
                        >
                            <img src="/main-logo.png" alt="Algovi" />
                        </a>
                    </p>
                    {/* {footer} */}
                </div>
            </div>
        </section>
    )
}
